@if (isOpen) {
<div class="settings-modal-overlay" (click)="closeModal()" role="dialog" aria-modal="true" aria-labelledby="share-modal-title">
  <div class="share-minimal-modal-card" (click)="$event.stopPropagation()">
    <header class="share-modal-header">
      @if (shareChannel !== 'select') {
      <button type="button" class="share-modal-back-btn" (click)="selectChannel('select')" aria-label="חזרה לבחירת ערוץ">
        <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <polyline points="9 18 15 12 9 6"></polyline>
        </svg>
      </button>
      }
      <h3 id="share-modal-title" class="share-modal-title">
        {{ shareChannel === 'select' ? shareTitle : (shareChannel === 'gmail' ? 'שיתוף ב-Gmail' : 'שיתוף ב-WhatsApp') }}
      </h3>
      <button type="button" class="settings-modal-close" (click)="closeModal()" aria-label="סגור חלון">×</button>
    </header>

    @if (shareChannel === 'select') {
    <p class="share-select-prompt">איך תרצו לשתף את הסל עם בן/בת הזוג או שותפים?</p>

    <div class="share-channel-grid">
      <button type="button" class="share-channel-btn share-channel-btn--gmail" (click)="selectChannel('gmail')">
        <div class="share-channel-icon-wrap gmail-icon-bg">
          <svg viewBox="0 0 24 24" width="26" height="26" fill="currentColor" aria-hidden="true">
            <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5-8-5V6l8 5 8-5v2z"/>
          </svg>
        </div>
        <span class="share-channel-label">Gmail</span>
        <span class="share-channel-sub">הזמנה ישירה לכתובת</span>
      </button>

      <button type="button" class="share-channel-btn share-channel-btn--whatsapp" (click)="selectChannel('whatsapp')">
        <div class="share-channel-icon-wrap whatsapp-icon-bg">
          <svg viewBox="0 0 24 24" width="26" height="26" fill="currentColor" aria-hidden="true">
            <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21 5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.82 9.82 0 0 0 12.04 2m.01 1.67c2.2 0 4.26.86 5.82 2.42a8.23 8.23 0 0 1 2.41 5.83c0 4.54-3.7 8.24-8.24 8.24-1.48 0-2.93-.4-4.2-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.2 8.2 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.24-8.24m4.52 11.75c-.25-.13-1.47-.72-1.7-.81-.23-.08-.39-.13-.56.13-.17.25-.64.81-.79.97-.14.17-.29.19-.54.06-.25-.13-1.06-.39-2.01-1.24-.74-.66-1.24-1.48-1.39-1.73-.14-.25-.02-.39.11-.51.11-.11.25-.29.37-.44.13-.15.17-.25.25-.42.08-.17.04-.31-.02-.44-.06-.13-.56-1.35-.77-1.85-.2-.49-.41-.42-.56-.43h-.48c-.17 0-.44.06-.67.31-.23.25-.88.86-.88 2.1 0 1.24.9 2.44 1.03 2.61.13.17 1.77 2.7 4.29 3.79.6.26 1.07.41 1.43.53.6.19 1.15.16 1.58.1.48-.07 1.47-.6 1.68-1.18.21-.58.21-1.08.15-1.18-.06-.1-.23-.16-.48-.29z"/>
          </svg>
        </div>
        <span class="share-channel-label">WhatsApp</span>
        <span class="share-channel-sub">שליחת קישור ישיר</span>
      </button>
    </div>

    @if (basket?.groupId) {
    <div class="share-modal-personal-link">
      <span>סל זה כבר מקושר לקבוצה.</span>
      <button type="button" class="btn-text-unlink" [disabled]="unlinkingPersonal" (click)="unlinkPersonalBasket()">
        {{ unlinkingPersonal ? 'מנתק…' : 'הפוך לסל אישי' }}
      </button>
    </div>
    }
    }

    @if (shareChannel === 'gmail') {
    <div class="share-channel-form">
      <label class="share-form-label" for="gmail-share-input">שם משתמש ב-Gmail:</label>
      <div class="share-input-affix-container" dir="ltr">
        <input id="gmail-share-input" type="text" class="share-minimal-input share-gmail-input"
          placeholder="username" [(ngModel)]="gmailUsername" dir="ltr" [disabled]="shareSubmitting"
          (keydown.enter)="submitGmailShare()">
        <span class="share-domain-badge" dir="ltr">&#64;gmail.com</span>
      </div>
      <p class="share-field-hint">נשלח הזמנה לחשבון ה-Gmail, והסל יופיע אצלם מיד כשיתחברו.</p>

      <button type="button" class="share-channel-submit-btn share-channel-submit-btn--gmail"
        [disabled]="!isGmailValid || shareSubmitting" (click)="submitGmailShare()">
        @if (shareSubmitting) {
        <span class="share-btn-spinner" aria-hidden="true"></span>
        }
        <span>{{ shareSubmitting ? 'משתף…' : 'שליחת הזמנה' }}</span>
      </button>
    </div>
    }

    @if (shareChannel === 'whatsapp') {
    <div class="share-channel-form">
      <label class="share-form-label" for="wa-share-input">מספר טלפון בישראל:</label>
      <div class="share-input-affix-container">
        <input id="wa-share-input" type="tel" class="share-minimal-input share-whatsapp-input"
          placeholder="050-1234567" [(ngModel)]="whatsappLocalPhone" dir="ltr" [disabled]="shareSubmitting"
          (keydown.enter)="submitWhatsAppShare()">
      </div>
      <p class="share-field-hint">נפתחת שיחת WhatsApp עם ההזמנה מוכנה. צריך ללחוץ שליחה בצ׳אט.</p>

      <button type="button" class="share-channel-submit-btn share-channel-submit-btn--whatsapp"
        [disabled]="!isWhatsAppValid || shareSubmitting || !whatsAppInviteLink" (click)="submitWhatsAppShare()">
        @if (shareSubmitting || !whatsAppInviteLink) {
        <span class="share-btn-spinner" aria-hidden="true"></span>
        }
        <span>{{ whatsAppInviteLink ? 'פתיחה ב-WhatsApp' : 'יוצר קישור…' }}</span>
      </button>
    </div>
    }

    @if (groupDetails?.members?.length) {
    <div class="share-members-section">
      <div class="share-members-header">
        <div class="share-members-title-group">
          <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
            <circle cx="9" cy="7" r="4"></circle>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
          </svg>
          <span class="share-members-title">חברים עם גישה לסל</span>
        </div>
        <span class="share-members-count-badge">{{ groupDetails!.members.length }}</span>
      </div>

      <ul class="share-members-list">
        @for (m of groupDetails!.members; track m.id) {
        <li class="share-member-item">
          <div class="share-member-avatar-wrap">
            @if (m.pictureUrl) {
              <img [src]="m.pictureUrl" alt="" class="share-member-avatar-img" />
            } @else {
              <span class="share-member-avatar-initial">{{ (m.givenName || m.invitedEmail || 'ח')[0].toUpperCase() }}</span>
            }
          </div>

          <div class="share-member-info">
            <div class="share-member-name-row">
              <span class="share-member-name">
                {{ m.givenName ? (m.givenName + ' ' + (m.familyName || '')) : (m.invitedEmail || 'משתמש') }}
              </span>
              @if (m.userId === auth.currentUser?.id) {
                <span class="share-member-self-tag">(את/ה)</span>
              }
              @if (m.role === 'owner') {
                <span class="share-role-chip share-role-chip--owner">בעלים</span>
              } @else if (m.status === 'invited') {
                <span class="share-role-chip share-role-chip--invited">ממתין להרשמה</span>
              } @else {
                <span class="share-role-chip share-role-chip--editor">עורך</span>
              }
            </div>
            @if (m.invitedEmail || (m.userId === auth.currentUser?.id && auth.currentUser?.email)) {
              <span class="share-member-email" dir="ltr">{{ m.invitedEmail || auth.currentUser?.email }}</span>
            }
          </div>

          @if (groupDetails!.role === 'owner' && m.userId !== auth.currentUser?.id && m.userId) {
            <button
              type="button"
              class="share-member-remove-btn"
              [disabled]="removingMemberUserId === m.userId"
              (click)="removeMember(m.userId)"
              title="הסרת חבר מהסל"
            >
              {{ removingMemberUserId === m.userId ? '…' : 'הסר' }}
            </button>
          }
        </li>
        }
      </ul>
    </div>
    }

    @if (shareSuccessMsg) {
    <p class="share-notice success" role="status">{{ shareSuccessMsg }}</p>
    }
    @if (shareErrorMsg) {
    <p class="share-notice error" role="alert">{{ shareErrorMsg }}</p>
    }
  </div>
</div>
}
